export const habaWishlist = {
  wishlistOverview: {
    title: 'My Lists',
    addNew: 'Create new wishlist',
    noWishlists: 'You have no lists',
    underConstruction: {
      headline: '"My wishlist" will be available again soon!',
      subHeadline: 'Due to a system adjustment, this function is currently unavailable.',
      list1: 'Temporarily use your cart to save your favorite products ',
      list2: 'You are welcome to sign up for the newsletter to be immediately informed about news',
      list3: 'Or discover our new products',
      buttonText: 'Discover our new products',
    },
  },
  wishlistCreate: {
    placeholder: 'Enter wishlist name',
    button: 'Save new wishlist',
    successMessage: 'Wishlist created',
    errorLengthMin: 'Name must be longer than three letters.',
    errorLengthMax: 'Name must be shorter than 100 letters',
    errorExitsAlready: 'Name already exists.',
    emptiedListSuccessMessage: 'Your products have been added to the cart',
    listCreated: 'Wishlist created',
    addNew: 'Create wishlist',
    title: 'Create list',
  },
  wishlistEdit: {
    edit: 'Edit list',
    rename: 'Rename list',
    delete: 'Delete list',
    successMessage: 'List edited',
    questionDelete: 'Do you really want to delete the wishlist and all contained products?',
  },
  wishlistList: {
    noItems: 'No entries in this list',
    allToBasket: 'Add all items to cart',
    deleteWishlist: 'Delete this wishlist',
    removedSuccessMessage: 'List removed',
    itemRemovedSuccessMessage: 'List updated',
    deletedList: 'Your wishlist has been deleted',
  },
  wishlistMove: {
    title: 'Move product',
    subtitle: 'Select a wishlist:',
    successMessage: 'Your product has been moved',
    warningCartsMessage: 'You only have 1 list',
  },
  wishlistAdd: {
    addToWishlist: 'Add to wishlist',
    addToWishlistTitle: 'Add to wishlist',
    addToCartSuccess: 'Your product has been added to the cart',
    warningSelectWishlist: 'You must first select a list',
    title: 'Please select list',
    noListsCreatedMessage:
      "You haven't created a wishlist yet. <br> Click below to create a new wishlist.",
    createWishlistAltText: 'or create a new list',
    addedToWishlist: 'Added to wishlist',
    addToWishlistLink: 'Add to wishlist',
    addedToWishlistNoticed: 'Add to wishlist',
    addInWishlist: 'Add to wishlist',
    removeFromWishlist: 'Remove from wishlist',
  },
  wishlistRemove: {
    main: {
      title: 'What would you like to do?',
      addToWishlist: 'ADD TO ANOTHER LIST',
    },
    secondary: {
      title: 'From which list should the item be deleted?',
    },
    removeFromWishlist: 'DELETE FROM WISHLIST',
  },
};
